export const isMobile = process.env.NEXT_PUBLIC_PLATFORM === 'mobile';
